<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <pre style="white-space: pre-wrap;">{{ payload }}</pre>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      payload: null,
    };
  },

  beforeMount() {
    this.payload = this.$route.params.payload;
  },
};
</script>

<style>
</style>